import { forwardRef, type ButtonHTMLAttributes } from "react";

import styles from "./button.module.css";
import { cx } from "./cx";

type Variant =
  | "primary"
  | "secondary"
  | "ghost"
  | "danger"
  | "dangerGhost"
  | "dangerSecondary";
type Size = "sm" | "md" | "lg";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "primary", size = "md", ...props }, ref) => {
    const cls = cx(
      styles.button,
      styles[variant],
      size !== "md" && styles[size],
      className,
    );

    return <button ref={ref} className={cls} {...props} />;
  },
);

Button.displayName = "Button";
